<template>
  <div>
    <a-drawer
      v-model:visible="drawerVisible"
      class="custom-class"
      :title="drawerTitle"
      placement="right"
      width="800px"
    >
      <h3>创建规则</h3>
      <a-form layout="inline">
        <a-row style="width: 100%">
          <a-col :span="12">
            <a-form-item label="国家">{{
              drawerInfo.countryCode
                ? `[${drawerInfo.countryCode}]${drawerInfo.countryName}`
                : drawerInfo.countryName
            }}</a-form-item>
          </a-col>
          <s-col :span="12">
            <a-form-item label="状态" required
              ><a-radio-group
                :disabled="isEdit"
                v-model:value="drawerInfo.status"
                :options="plainOptions"
            /></a-form-item>
          </s-col>
        </a-row>
      </a-form>
      <a-divider />
      <div style="display: flex;align-items: flex-end;">
        <h3>设置动作</h3>
        <a
          type="link"
          style="margin-left: 10px;"
          href="https://poe.com/ChatGPT"
          target="_blank"
          >(正则表达式查询入口)</a
        >
      </div>
      <div class="selfCollapse">
        <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-collapse v-model:activeKey="activeKey" ghost>
            <a-collapse-panel
              v-for="(item,
              index) in drawerInfo.addressValidateConfigDetailDTOList"
              :key="index + 1"
              :header="'处理规则' + (index + 1) + '&nbsp;&nbsp;' + item.name"
            >
              <a-form-item label="是否展示" v-if="item.isShow">
                <a-radio-group :disabled="isEdit" v-model:value="item.showFlag">
                  <a-radio :value="true">是</a-radio>
                  <a-radio :value="false">否</a-radio>
                </a-radio-group>
                <a-button
                  type="link"
                  @click="item.showFlag = null"
                  :disabled="isEdit"
                  >取消选择</a-button
                >
              </a-form-item>
              <a-form-item label="必填校验">
                <a-radio-group
                  :disabled="isEdit"
                  v-model:value="item.required"
                  :options="requiredOption"
                />
                <a-button
                  type="link"
                  @click="cnacelRequired(index)"
                  :disabled="isEdit"
                  >取消选择</a-button
                >
              </a-form-item>
              <a-form-item label="格式校验">
                <a-input
                  :disabled="isEdit"
                  v-model:value="item.regularDesc"
                  placeholder="请输入规则需求"
                  :maxlength="255"
                />
              </a-form-item>
              <a-form-item label="后端正则">
                <a-input
                  :disabled="isEdit"
                  v-model:value="item.regularExpression"
                  placeholder="请输入后端正则表达式"
                  :maxlength="255"
                />
              </a-form-item>
              <a-form-item label="WEB端正则">
                <a-input
                  :disabled="isEdit"
                  v-model:value="item.webRegularExpression"
                  placeholder="请输入Web端正则表达式"
                  :maxlength="255"
              /></a-form-item>
              <a-form-item label="APP端正则"
                ><a-input
                  :disabled="isEdit"
                  v-model:value="item.appRegularExpression"
                  placeholder="请输入App端正则表达式"
                  :maxlength="255"
              /></a-form-item>
              <a-form-item
                v-for="(i, idx) in item.errorPromptDTOList"
                :key="idx"
                :label-col="idx === 0 ? { span: 4 } : { span: 0 }"
                :wrapper-col="
                  idx === 0 ? { span: 20 } : { span: 24, offset: 4 }
                "
                :label="idx === 0 ? '不符合规则提示' : ''"
              >
                <a-input-group compact>
                  <a-select
                    v-model:value="i.langCode"
                    :disabled="i.langCode === 'en-GB' || isEdit"
                    style="width: 20%"
                    showSearch
                    :filter-option="filterOption"
                    allowClear
                    placeholder="语言"
                  >
                    <a-select-option
                      v-for="items in languageOptionList"
                      :key="items.value"
                      :value="items.value"
                      :label="items.label"
                      :disabled="
                        alreadySelectLanguage[item.type].indexOf(items.value) >=
                          0
                      "
                      >{{ items.label }}</a-select-option
                    >
                  </a-select>
                  <a-input
                    :disabled="isEdit"
                    v-model:value="i.prompt"
                    style="width: 70%"
                    :maxlength="255"
                    placeholder="请输入提示文案"
                  />
                  <p style="line-height: 34px;width: 10%" v-if="!isEdit">
                    <plus-circle-outlined
                      :style="{
                        margin: '0 5px',
                        color: '#ffc53d',
                        cursor: 'pointer',
                        fontSize: '16px'
                      }"
                      @click="addLanguageItem(index)"
                    />
                    <minus-circle-outlined
                      :style="{
                        margin: '0 5px',
                        color: '#46a6ff',
                        cursor: 'pointer',
                        fontSize: '16px'
                      }"
                      @click="removeLabguageItem(index, idx)"
                      v-if="idx !== 0"
                    />
                  </p>
                </a-input-group>
              </a-form-item>
            </a-collapse-panel>
          </a-collapse>
        </a-form>
      </div>
      <template #footer>
        <div style="text-align: right;">
          <a-button
            style="margin-right: 8px"
            @click="() => (drawerVisible = false)"
            >取消</a-button
          >
          <a-button type="primary" @click="submitRules" :disabled="isEdit"
            >确认</a-button
          >
        </div>
      </template>
    </a-drawer>
  </div>
</template>
<script>
import { defineComponent, inject, reactive, toRefs } from 'vue'
import { PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons-vue'
export default defineComponent({
  name: 'AddressRule',
  components: { PlusCircleOutlined, MinusCircleOutlined },
  setup() {
    const state = reactive({
      activeKey: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      plainOptions: [
        {
          label: '启用',
          value: 1
        },
        {
          label: '禁用',
          value: 0
        }
      ],
      requiredOption: [
        {
          label: '必填',
          value: true
        },
        {
          label: '非必填',
          value: false
        }
      ]
    })
    return {
      ...toRefs(state),
      ...toRefs(inject('initState'))
    }
  }
})
</script>
<style>
.selfCollapse .ant-collapse-header {
  font-size: 18px;
  font-weight: bold;
}
.selfCollapse .ant-form-item {
  margin-bottom: 16px;
}
</style>
